export default __webpack_public_path__ + "static/media/arrow_down.0c33050f.svg";